<template>
<!--  <Panel :header="$t('Payments') + (periodLabel ? ' (' + periodLabel + ')' : '')" :toggleable="false" :collapsed="isCollapsed">-->
  <Panel :toggleable="false" :collapsed="isCollapsed">
    <template #header>
      <div class="statistics-panel-header">
        <b>{{ $t('Payments') }}</b>
        <span v-if="periodLabel" class="p-text-secondary statistics-panel-date">
          {{ periodLabel }}
        </span>
      </div>
    </template>
    <div class="datatable-wrapper" v-if="payments">
      <table class="p-datatable p-datatable-striped p-datatable-sm p-datatable-hoverable-rows positions-table">
        <thead class="p-datatable-tbody">
        <!--        <thead class="p-datatable-thead">-->
        <tr class="table-opened-info__header-row">
          <th style="width: 40%">{{ $t('Type') }}</th>
          <th style="width: 20%">{{ $t('transactionsLabel') }}</th>
          <th style="width: 20%">{{ $t('Total sum') }}</th>
          <th style="width: 20%">{{ $t('Percent') }}</th>
        </tr>
        </thead>
        <tbody class="p-datatable-tbody">
        <tr v-if="payments?.card">
          <td>{{ $t('cardPaymentsLabel') }}</td>
          <td>{{ payments.card.count ?? 0 }}</td>
          <td>{{ formatCurrency(payments.card.sum) }}</td>
          <td>{{ calculatePercent(payments.card.sum) }}%</td>
        </tr>
        <tr v-if="payments?.cash">
          <td>{{ $t('cashPaymentsLabel') }}</td>
          <td>{{ payments.cash.count ?? 0 }}</td>
          <td>{{ formatCurrency(payments.cash.sum) }}</td>
          <td>{{ calculatePercent(payments.cash.sum) }}%</td>
        </tr>
        <tr v-if="payments?.bank">
          <td>{{ $t('bankTransfersLabel') }}</td>
          <td>{{ payments.bank.count ?? 0 }}</td>
          <td>{{ formatCurrency(payments.bank.sum) }}</td>
          <td>{{ calculatePercent(payments.bank.sum) }}%</td>
        </tr>
        <tr v-if="payments" class="table-opened-info__row--total">
          <td class="no-bottom-border">{{ $t('Total') }}</td>
          <td class="no-bottom-border">{{ payments.total_count ?? 0 }}</td>
          <td class="no-bottom-border">{{ formatCurrency(payments.total_sum) }}</td>
          <td class="no-bottom-border"></td>
        </tr>
        </tbody>
      </table>
    </div>
    <div v-else style="text-align: center; padding: 20px;">
      {{ $t('No data available' )}}
    </div>
  </Panel>
</template>

<script>
import formatMixins from "@/mixins/formatMixins";
export default {
  mixins: [ formatMixins ],
  name: 'PaymentsPanel',
  props: {
    periodLabel: { type: String, default: '' },
    payments: {
      type: Object,
      default: null
    }
  },
  data: () => {
    return {
      isCollapsed: false,
    }
  },
  methods: {
    calculatePercent(sum) {
      const total = Number(this.payments?.total_sum || 0)
      const value = Number(sum || 0)

      if (!total || !value) return 0

      return this.formatDecimal(value * 100 / total)
    }
  }
}
</script>